export const ROLES_CONST = {
  companyAdmin: 'companyAdmin',
  companyStaff: 'companyStaff',
  providerAdmin: 'providerAdmin',
  providerStaff: 'providerStaff',
  centreAdmin: 'centreAdmin',
  centreStaff: 'centreStaff',
};
